import { render, staticRenderFns } from "./intranetBusinessMemberRoleManagement.vue?vue&type=template&id=2cd33389&scoped=true"
import script from "./intranetBusinessMemberRoleManagement.vue?vue&type=script&lang=js"
export * from "./intranetBusinessMemberRoleManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd33389",
  null
  
)

export default component.exports